"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onPushToPkgDetails = exports.onPushToDash = exports.onGoBack = exports.getPackage = exports.deletePackage = exports.saveSearchTerm = exports.getPackageSuccess = exports.getPackageRequest = void 0;
var connected_react_router_1 = require("connected-react-router");
var typesafe_actions_1 = require("typesafe-actions");
var models_1 = require("@app/_state/models");
var utils_1 = require("@app/_state/utils");
var PackagesApi = __importStar(require("@app/services/api/packages"));
var matomo_1 = require("@app/shared/matomo");
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.getPackageRequest = createAction('@@packages/GET_PACKAGE_REQUEST', function (resolve) { return function (packageId) { return resolve(packageId); }; });
exports.getPackageSuccess = createAction('@@packages/GET_PACKAGE_SUCCESS', function (resolve) { return function (packageDetails) { return resolve(packageDetails); }; });
exports.saveSearchTerm = createAction('@@packages/SAVE_SEARCH_TERM', function (resolve) { return function (searchTerm) { return resolve(searchTerm); }; });
/* Action Creators - end */
/* Packages Details' Action Functions - begin */
var deletePackage = function (packageId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PackagesApi.deletePackage(packageId)];
                case 1:
                    _a.sent();
                    dispatch(connected_react_router_1.goBack());
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.deletePackage = deletePackage;
var getPackage = function (packageId, force, debug) {
    if (force === void 0) { force = false; }
    if (debug === void 0) { debug = false; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, details;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.getPackageRequest(packageId));
                    return [4 /*yield*/, PackagesApi.getPackage(packageId, force, debug)];
                case 1:
                    details = _a.sent();
                    // checkAsperaTransfers returns an array, so must specify the array index
                    dispatch(exports.getPackageSuccess(utils_1.checkAsperaTransfers(state.transfers.asperaTransfers, details, models_1.PackageView.DETAILS)[0]));
                    new matomo_1.MatomoTracker().trackEvent('Package Details', 'View Package', packageId);
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.getPackage = getPackage;
var onGoBack = function () {
    return function (dispatch) {
        dispatch(connected_react_router_1.goBack());
    };
};
exports.onGoBack = onGoBack;
var onPushToDash = function () {
    return function (dispatch) {
        dispatch(connected_react_router_1.push('/dash'));
    };
};
exports.onPushToDash = onPushToDash;
var onPushToPkgDetails = function (packageId) {
    return function (dispatch) {
        dispatch(connected_react_router_1.push("/dash/packages/" + packageId));
    };
};
exports.onPushToPkgDetails = onPushToPkgDetails;
/* Packages Details' Action Functions - end */
